import React from "react";

import { IProduct } from "../../models/catalogue";
import { IGA4ListMetadata } from "../../utils/analytics";
import { defaultProductCompareListMetadata } from "./analytics.shared";

type IProductCompareAnalyticsContext = {
    listMetadata: IGA4ListMetadata;
    viewedProducts: readonly IProduct[];
};

const ProductCompareAnalyticsContext =
    React.createContext<IProductCompareAnalyticsContext>({
        listMetadata: defaultProductCompareListMetadata,
        viewedProducts: [],
    });

export const ProductCompareAnalyticsProvider = (
    props: React.PropsWithChildren<IProductCompareAnalyticsContext>,
) => {
    const value = React.useMemo(
        () => ({
            listMetadata: props.listMetadata,
            viewedProducts: props.viewedProducts,
        }),
        [props.listMetadata, props.viewedProducts],
    );

    return (
        <ProductCompareAnalyticsContext.Provider value={value}>
            {props.children}
        </ProductCompareAnalyticsContext.Provider>
    );
};

export const useProductCompareAnalytics = () => {
    return React.useContext(ProductCompareAnalyticsContext);
};
